import { View, Text } from 'react-native';
import type { getGroupsViewCardStyles } from './GroupsViewCard.styles';

interface GroupsViewMemberStackProps {
  memberCount: number;
  styles: ReturnType<typeof getGroupsViewCardStyles>;
  isRecessed: boolean;
}

export function GroupsViewMemberStack({ memberCount, styles, isRecessed }: GroupsViewMemberStackProps) {
  const n = Math.max(0, Math.floor(memberCount));
  const shown = n <= 0 ? 0 : Math.min(2, n);
  const overflow = n > 2 ? n - 2 : 0;

  const ring = isRecessed ? styles.memberDotOnRecessed : null;
  const overflowRing = isRecessed ? styles.memberOverflowOnRecessed : null;

  if (shown === 0) {
    return (
      <View style={styles.memberStack}>
        <View style={[styles.memberDot, styles.memberDotEmpty, styles.memberDotLast, ring]} />
      </View>
    );
  }

  return (
    <View style={styles.memberStack}>
      {Array.from({ length: shown }, (_, i) => {
        const isLast = i === shown - 1 && overflow === 0;
        const tint = i % 2 === 0 ? styles.memberDotTintA : styles.memberDotTintB;
        return (
          <View
            key={`m-${i}`}
            style={[styles.memberDot, tint, ring, isLast && styles.memberDotLast]}
          />
        );
      })}
      {overflow > 0 && (
        <View style={[styles.memberOverflowChip, overflowRing]}>
          <Text style={styles.memberOverflowText}>+{overflow}</Text>
        </View>
      )}
    </View>
  );
}
